import classNames from 'classnames';
import { format } from 'date-fns';
import {
  isClosedStatoScommessa,
  isDifferentStatoScommessaByKey,
  isEqualStatoScommessaByKey,
  retriveStatoScommessaByKey,
} from 'features/ippica/functions';
import { selectIppicaTodayDictionary } from 'features/ippica/selectors';
import { Stato } from 'features/ippica/types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styles from './IppicaTableRowPosition.module.scss';

export type IppicaTableRowPositionProps = {
  keyAvvenimento: string;
  containerClassName?: string;
};

export const IppicaTableRowPosition = ({ keyAvvenimento, containerClassName }: IppicaTableRowPositionProps) => {
  const { numeroCorsa, dataOraAvvenimento, codiceStatoAvvenimento } =
    useSelector(selectIppicaTodayDictionary(keyAvvenimento)) ?? {};

  const { className, showStatus, statoTipoScommessa } = useMemo(() => {
    const show =
      isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa) ||
      isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento);
    if (show) {
      return {
        className: styles[isClosedStatoScommessa(codiceStatoAvvenimento)],
        showStatus: true,
        statoTipoScommessa: retriveStatoScommessaByKey(codiceStatoAvvenimento).slice(0, 7),
      };
    }

    return {
      className: '',
      showStatus: false,
    };
  }, [codiceStatoAvvenimento]);

  const { showData, dataOra } = useMemo(() => {
    const show =
      isDifferentStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa) ||
      isDifferentStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento);

    if (show && dataOraAvvenimento) {
      return {
        showData: true,
        dataOra: format(new Date(dataOraAvvenimento)!, 'kk:mm'),
      };
    }
    return { showData: false, dataOra: '' };
  }, [codiceStatoAvvenimento, dataOraAvvenimento]);

  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      <span className={styles.number}>{numeroCorsa}</span>
      {showStatus && <span className={classNames(styles.status, className)}>{statoTipoScommessa}</span>}
      {showData && <span className={styles.hour}>{dataOra}</span>}
    </div>
  );
};
